import api from './api';

export const getExternalInputQueue = (departmentId) =>
  api.get('/kra/external-inputs/queue', { params: departmentId ? { department_id: departmentId } : {} });

export const submitExternalInput = (cycleId, data) =>
  api.post('/kra/external-inputs', data, { params: { cycle_id: cycleId } });
